import React from "react";

// No mode (the legacy players) lists every shortcut.
export default function ShortcutsList({ mode }) {
  const isPlayingFlashcard = mode === "flashcard";
  const isPlayingTextInput = !mode || mode === "text_input";
  const isTypingAnswer = mode === "text_input" || mode === "full_text_input";
  const hasMultipleChoiceOptions = isPlayingTextInput || mode === "multiple_choice";
  const isPlayingSpeaking = !mode || mode === "speaking";

  return (
    <div>
      <table className="table table-striped">
        <tbody>
          {isPlayingFlashcard ? (
            <>
              <tr>
                <td>Enter</td>
                <td className="text-left">Turn the card over, then press again to grade it Good; next round on the round results</td>
              </tr>
              <tr>
                <td>Space</td>
                <td className="text-left">Turn the card over to see the answer (never grades it)</td>
              </tr>
              <tr>
                <td>&rarr; / &larr;</td>
                <td className="text-left">Grade the card Good (you knew it, counts as correct) or Again (you didn't, counts as incorrect)</td>
              </tr>
            </>
          ) : (
            <>
              <tr>
                <td>Enter</td>
                <td className="text-left">Submit answer, next sentence, next round / next collection</td>
              </tr>
              {!isTypingAnswer && (
                <tr>
                  <td>Space / &rarr;</td>
                  <td className="text-left">Next sentence</td>
                </tr>
              )}
            </>
          )}
          {hasMultipleChoiceOptions && (
            <tr>
              <td>1-4</td>
              <td className="text-left">Select multiple choice answer</td>
            </tr>
          )}
          <tr>
            <td>1 / 2 / 3</td>
            <td className="text-left">With Next review open after answering: Hard, keep the usual review date, Easy</td>
          </tr>
          <tr>
            <td>ctl+Space</td>
            <td className="text-left">Replay audio (when available)</td>
          </tr>
          <tr>
            <td>shift+ctl+Space</td>
            <td className="text-left">Play slow audio (when available)</td>
          </tr>
          {isPlayingSpeaking && (
            <tr>
              <td>ctl+Enter</td>
              <td className="text-left">Record audio (for speaking)</td>
            </tr>
          )}
          <tr>
            <td>alt+a</td>
            <td className="text-left">Add current sentence to a collection  <small className="joystix"><em>Pro!</em></small></td>
          </tr>
          <tr>
            <td>alt+c</td>
            <td className="text-left">Open collection search <small className="joystix"><em>Pro!</em></small></td>
          </tr>
          <tr>
            <td>alt+d</td>
            <td className="text-left">Edit current sentence <small className="joystix"><em>Pro!</em></small></td>
          </tr>
          <tr>
            <td>alt+g</td>
            <td className="text-left">Toggle grammar after answering (when available)</td>
          </tr>
          <tr>
            <td>alt+e</td>
            <td className="text-left">Report current sentence error</td>
          </tr>
          <tr>
            <td>alt+f</td>
            <td className="text-left">Toggle favorite <small className="joystix"><em>Pro!</em></small></td>
          </tr>
          {isPlayingTextInput && (
            <tr>
              <td>alt+h</td>
              <td className="text-left">Use hint when playing text input</td>
            </tr>
          )}
          <tr>
            <td>alt+i</td>
            <td className="text-left">Ignore current sentence</td>
          </tr>
          <tr>
            <td>alt+k</td>
            <td className="text-left">Mark current sentence as 'Known' (100% Mastered and next review year 2100)</td>
          </tr>
          <tr>
            <td>alt+m</td>
            <td className="text-left">Set current sentence to '100% Mastered'</td>
          </tr>
          {isPlayingTextInput && (
            <tr>
              <td>alt+p</td>
              <td className="text-left">Switch current sentence to multiple choice</td>
            </tr>
          )}
          <tr>
            <td>alt+r</td>
            <td className="text-left">Reset current sentence to '0% Mastered'; on the round results, Redo this round (when offered)</td>
          </tr>
          <tr>
            <td>alt+s</td>
            <td className="text-left">Open sentence search <small className="joystix"><em>Pro!</em></small></td>
          </tr>
          <tr>
            <td>alt+t</td>
            <td className="text-left">Toggle translation</td>
          </tr>
          <tr>
            <td>alt+u</td>
            <td className="text-left">Open sentence discussion <small className="joystix"><em>Pro!</em></small></td>
          </tr>
          <tr>
            <td>alt+v</td>
            <td className="text-left">Speak it: record yourself saying the sentence (with More Practice on)</td>
          </tr>
          <tr>
            <td>R / P / A</td>
            <td className="text-left">In Speak it: record or stop, play your recording, sentence audio (shift+A half speed); Enter closes</td>
          </tr>
          <tr>
            <td>alt+w</td>
            <td className="text-left">Write it: type the sentence out (with More Practice on)</td>
          </tr>
          <tr>
            <td>alt+x</td>
            <td className="text-left">Toggle image (if available)</td>
          </tr>
          <tr>
            <td>shift+alt+x</td>
            <td className="text-left">Toggle explanation (if available)</td>
          </tr>
          <tr>
            <td>alt+y</td>
            <td className="text-left">Open round history</td>
          </tr>
        </tbody>
      </table>
      <em><small>*Different browsers may handle shortcut keys differently. Please let us know if you notice any issues.</small></em>
    </div>
  );
}
